import { Variant } from '@/types/menus.types';
import styles from './TabProductsExcluded.module.css';
import { Grid, ListItem } from '@mui/material';

export const TabProductsExcluded = ({ variants }: { variants: Variant[] }) => {
  const sortedProducts = variants?.sort((a, b) => a.productName.localeCompare(b.productName));
  return (
    <div className={styles.productsExcluded}>
      <div className={styles.productsExcludedInfo}>Products Excluded</div>
      <span>These products will not be updated for the listed stores because they are not on the menu.</span>
      <Grid container direction="row" justifyContent="space-between" alignItems="left">
        <Grid item>
          <ul>
            {sortedProducts
              ?.filter((storeProduct) => storeProduct.excludedStores.length > 0)
              .map((storeProduct) => (
                <ListItem key={storeProduct.variantId}>
                  <li>
                    <span className={styles.productsExcludedDescription}>
                      {storeProduct.productName}, {storeProduct.productDescription}
                    </span>
                    <ul>
                      {storeProduct?.excludedStores?.map((excludedStore) => (
                        <li key={excludedStore.storeGroup}>
                          <span className={styles.productsStoreGroup}>{excludedStore.storeGroup}:</span>
                          {excludedStore.stores.join(', ')}
                        </li>
                      ))}
                    </ul>
                  </li>
                </ListItem>
              ))}
          </ul>
        </Grid>
      </Grid>
    </div>
  );
};
